import React from "react";
import { Flex, Box, Text, Icon, Button, useColorModeValue } from "@chakra-ui/react";
import { MdRefresh } from "react-icons/md";

/**
 * Shared panel header: brand icon badge, title, subtitle and optional refresh button.
 * @param {Object} props - Header props
 * @param {React.ElementType} props.icon - react-icons component for the badge
 * @param {string} [props.iconColor] - Icon color token (defaults to brand.500)
 * @param {string} props.title - Panel title
 * @param {string} props.subtitle - Panel subtitle
 * @param {Function} [props.onRefresh] - Refresh handler; button hidden when absent
 * @param {boolean} [props.refreshing] - Loading state for the refresh button
 * @returns {React.ReactElement}
 */
function PaymentPanelHeader({ icon, iconColor, title, subtitle, onRefresh, refreshing }) {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Flex justify="space-between" align="flex-start" mb="20px" gap="12px" flexWrap="wrap">
            <Flex align="center" gap="12px">
                <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg} flexShrink="0">
                    <Icon as={icon} w="24px" h="24px" color={iconColor || "brand.500"} />
                </Flex>
                <Box>
                    <Text fontSize="lg" fontWeight="700" color={titleColor}>{title}</Text>
                    <Text fontSize="sm" color={subColor}>{subtitle}</Text>
                </Box>
            </Flex>
            {onRefresh && (
                <Button onClick={onRefresh} isLoading={refreshing} leftIcon={<Icon as={MdRefresh} />}
                    size="sm" variant="outline" colorScheme="brand">Recharger</Button>
            )}
        </Flex>
    );
}

export default PaymentPanelHeader;
